<template>
	<div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Ingreso de valores de rubros para recaudadores</h3>
      </div>
      <div class="layout__controls">
				<div class="form-inline">
          <button 
            @click="consultar" 
            class="btn-info btn--bigger"
            v-if="!consultaRealizada || form.registros.length == 0"
          >
						<i class="fa fa-search"></i><span>Consultar</span>
					</button>
					<button 
            @click="exportar" 
            class="btn-success btn--bigger"
          >
						<i class="fa fa-file-excel-o"></i><span>Generar Excel</span>
					</button>          
          <button
            @click="guardar"
            class="btn-success btn--bigger"
            v-if="consultaRealizada && form.registros.length > 0"
          >
            <i class="fa fa-save"></i><span>Guardar</span>
          </button>
				</div>
			</div>
    </div>
    <div class="card mt-2">
			<div class="card__content">
        <div class="row">          
          <div class="col-xs-12 col-md-3">
            <div
              class="form-field select2 select2-field--stretch"
              :class="{ 'select2--disabled': form.idsRecaudadores.length > 0 || (consultaRealizada && form.registros.length > 0)}"
            >
              <div class="select2-field">
                <v-select 
                  :filterable="false" 
                  @input="inputBodega" 
                  label="descripcion" 
                  placeholder="Seleccione..."
                  :options="bodegas" 
                  id="bodegas" 
                  v-model="selectedBodega"
                ></v-select>
                <label for="bodegas">Sucursal:</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-3">
            <div class="form-field">
              <input-field
                :disabled="form.mes == null || (consultaRealizada && form.registros.length > 0)"
                type="tel"
                v-mask="'####'"
                id="anio"
                v-model="form.anio"
                placeholder="####"
              >
                <strong>Año:</strong>
              </input-field>
            </div>
          </div>
          <div class="col-xs-12 col-md-3">
            <div
              class="form-field select2 select2-field--stretch"
              :class="{ 'select2--disabled': (consultaRealizada && form.registros.length > 0) || form.anio.length != 4}"
            >
              <div class="select2-field">
                <v-select 
                  :filterable="false" 
                  @input="inputMes" 
                  label="descripcion" 
                  placeholder="Seleccione..."
                  :options="meses" 
                  id="mes" 
                  v-model="selectedMes"
                ></v-select>
                <label for="mes">Mes:</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-3">
            <div
              class="form-field select2 select2-field--stretch"
              :class="{ 'select2--disabled': (consultaRealizada && form.registros.length > 0) || form.mes == null}"
            >
              <div class="select2-field">
                <v-select 
                  :filterable="false" 
                  @input="inputSemana" 
                  label="descripcion" 
                  placeholder="Seleccione..."
                  :options="semanas" 
                  id="semana" 
                  v-model="selectedSemana"
                ></v-select>
                <label for="semana">Semana:</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12" v-show="form.bodega_id != null">
            <div class="form-field select2 select2-field--stretch"
              :class="{ 'select2--disabled': (consultaRealizada && form.registros.length > 0)}"
            >
              <div class="select2-field">
                <v-select
                  :filterable="false"
                  @search="onSearchUsuarios"
                  @input="inputUsuarios"
                  label="nombre"
                  placeholder="Seleccione..."
                  :options="recaudadores"
                  id="usuarios"
                  v-model="selectedRecaudadores"
                  multiple
                ></v-select>
                <label for="usuarios">Recaudadores:</label>
              </div>
            </div>
          </div>
        </div>    
      </div>
    </div>
    <div class="card mt-2" v-show="form.registros.length > 0">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 mt-2">
            <tablaIngresoRubros
              :registros="form.registros"
              :rubros="rubros"
              :puedeCerrar="puedeCerrar"
            ></tablaIngresoRubros>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {	
	data: function () {
		return {
      puedeCerrar: false,
      bodegas: [],
      selectedBodega: null,
      recaudadores: [],
      selectedRecaudadores: [],
      consultaRealizada: false,   
      selectedMes: null,  
      rubros: [],       
      form: {
        bodega_id: null,
        anio: moment(new Date()).format('YYYY'),
        mes: null,
        numeroSemana: null,
        fechaDesde: null,
        fechaHasta: null,
        idsRecaudadores: [],
        registros: [],
      },
      semanas: [],
      selectedSemana: null,
      meses: [
        { id: 1, descripcion: 'ENERO' },
        { id: 2, descripcion: 'FEBRERO' },
        { id: 3, descripcion: 'MARZO' },
        { id: 4, descripcion: 'ABRIL' },
        { id: 5, descripcion: 'MAYO' },
        { id: 6, descripcion: 'JUNIO' },
        { id: 7, descripcion: 'JULIO' },
        { id: 8, descripcion: 'AGOSTO' },
        { id: 9, descripcion: 'SEPTIEMBRE' },
        { id: 10, descripcion: 'OCTUBRE' },
        { id: 11, descripcion: 'NOVIEMBRE' },
        { id: 12, descripcion: 'DICIEMBRE' },
      ],
    }
  },
  watch: {
    'form.anio': function(value) {
      let anioActual = moment(new Date()).format('YYYY');
      if(value.length == 4){
        if(parseInt(value) > parseInt(anioActual))
          this.form.anio = anioActual;
      }
    },
  },
  methods: {
    inputMes: function () {
      this.form.mes = this.selectedMes != null 
        ? this.selectedMes.id
        : null;
      this.calcularSemanas();
    },
    inputSemana: function () {
      if(this.selectedSemana != null){
        this.form.numeroSemana = this.selectedSemana.numero_semana;
        this.form.fechaDesde = this.selectedSemana.fecha_desde;
        this.form.fechaHasta = this.selectedSemana.fecha_hasta;
      }
      else{
        this.form.numeroSemana = null;
        this.form.fechaDesde = null;
        this.form.fechaHasta = null;
      }
    },
    calcularSemanas: function() {
      this.semanas.splice(0, this.semanas.length);
      this.selectedSemana = null;
      this.form.numeroSemana = null;
      let mes = this.form.mes;
      let anio = this.form.anio; 
      //Seteando los objetos de semanas
      if(anio.length == 4 && mes != null){
        //Validando que el mes no sea futuro
        let mesActual = parseInt(moment(new Date()).format('MM'));
        let anioActual = parseInt(moment(new Date()).format('YYYY'));
        if(parseInt(anio) == anioActual && parseInt(mes) > mesActual){
          swal.fire('Aviso', 'No se puede seleccionar un mes futuro', 'warning');
          return;
        }
        /***************************/
        let fechaFinalMes = moment(new Date(`${anio}-${mes.toString().padStart(2, '0')}-01 00:00:00`)).endOf('month'); 
        let numeroSemana = 0;
        let diaInicial = 1;
        let diaFinalMes = parseInt(fechaFinalMes.format('DD'));
        let salir = false;
        do {   
          numeroSemana++;       
          let diaFinal = diaInicial + 6;
          if((diaInicial + 6) >= diaFinalMes){
            diaFinal = diaFinalMes;
            salir = true;
          }
          let fechaDesde = moment(`${anio}-${mes.toString().padStart(2, '0')}-${diaInicial.toString().padStart(2, '0')}`).format('YYYY-MM-DD hh:mm');
          let fechaHasta = moment(`${anio}-${mes.toString().padStart(2, '0')}-${diaFinal.toString().padStart(2, '0')}`).format('YYYY-MM-DD hh:mm');
          let obj = {
            numero_semana: numeroSemana,
            fecha_desde: fechaDesde,
            fecha_hasta: fechaHasta,
            descripcion: `Del ${diaInicial} al ${diaFinal}`,
          };
          this.semanas.push(obj);
          diaInicial = (diaFinal + 1);
        } while(!salir);
      }
    },
    inputUsuarios: function () {
      this.form.idsRecaudadores.splice(0, this.form.idsRecaudadores.length);
      this.form.idsRecaudadores = this.selectedRecaudadores.map(
        (usuario) => usuario.id
      );
    },
    inputBodega: function() {
			if (this.selectedBodega != null)
				this.form.bodega_id = this.selectedBodega.id;
			else
				this.form.bodega_id = null;
      this.selectedRecaudadores.splice(0, this.selectedRecaudadores.length);
      this.form.idsRecaudadores.splice(0, this.form.idsRecaudadores.length);
		},
    onSearchUsuarios: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.recaudadores = json;
          loading(false);
        } else loading(false);
      };
      let urlApi = "";
      urlApi = `${url}/search/usuarios?search=${search}&tipo=R&bodega_id=${that.form.bodega_id}`;
      xmlhttp.open("GET", urlApi, true);
      xmlhttp.send();
    },
    validarFormulario: function() {
      if (this.form.bodega_id == null) {
        swal("Aviso", "La sucursal es requerida", "warning");
        return false;
      }      
      if (this.form.mes == null) {
        swal("Aviso", "El mes es requerido", "warning");
        return false;
      }
      if (this.form.numeroSemana == null || this.form.fechaDesde == null || this.form.fechaHasta == null) {
        swal("Aviso", "La semana es requerida", "warning");
        return false;
      }
      return true;
    },
    clickConsulta: function() {
      if(!this.validarFormulario())
        return;
      if(this.form.registros.length > 0){
        let that = this;   
        swal({
          title: "¿Desea consultar nuevamente?",
          text: "No se almacenarán los cambios realizados que no hayan sido guardados",
          type: "question",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result.value) {
            that.consultar();
          }
        });  
      }
      else
        this.consultar();
      
    },
    consultar: function() {         
      this.rubros.splice(0, this.rubros.length);
      this.form.registros.splice(0, this.form.registros.length);
      this.consultaRealizada = false;
      let urlApi = `${url}/ingreso-rubros-nomina/consultar`;
      axios
        .post(urlApi, this.form)
        .then(response => {
          let data = response.data;
          this.form.registros = [...data.registros];
          this.rubros = [...data.rubros];
          if(data.rubros.length == 0){
            swal.fire('Aviso', 'No se encontró ningún rubro', 'warning');
            return;
          }
          if(data.registros.length == 0){
            swal.fire('Aviso', 'No se encontró ningún recaudador', 'warning');
            return;
          }
          this.consultaRealizada = true;
        })
        .catch(error => {
          swal.fire('Error', 'No se pudo realizar la consulta', 'error');
        });
    },
    guardar: function() {
      if(this.form.registros.length == 0){
        swal.fire('Aviso', 'No se puede guardar ya que no se encontraron registros...', 'warning');
        return;
      }
      let that = this;
      swal({
        title: "¿Desea guardar los cambios en los registros?",
        text: "",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          let urlApi = `${url}/ingreso-rubros-nomina/guardar`;
          axios
            .post(urlApi, that.form)
            .then(response => {
              swal.fire('Realizado', 'Los registros han sido almacenados correctamente', 'success');
            })
            .catch(error => {
              // console.log('error: ', error);
              swal.fire('Error', 'No se pudo realizar el guardado de los registros', 'error');
            });
        }
      });      
    },
    exportar: function() {
      //
    },
    cargarFormulario: function() {
      let urlApi = `${url}/ingreso-rubros-nomina/cargar-formulario`;
      axios
        .get(urlApi)
        .then(response => {
          let data = response.data;
          this.puedeCerrar = data.puedeCerrar;
          this.bodegas = [...data.bodegas];
          if(data.bodegas.length == 1){
            this.selectedBodega = data.bodegas[0];
            this.form.bodega_id = data.bodegas[0].id;
          }
        })
        .catch(error => {
          swal.fire('Error', 'No se pudo cargar la pantalla correctamente', 'error');
        });
    }
  },
  mounted: function() {
    this.cargarFormulario();
    let mesActual = parseInt(moment(new Date()).format('MM'));
    this.meses.forEach(mes => {
      if(mesActual == mes.id){
        this.selectedMes = mes;
        this.form.mes = mes.id;
        this.calcularSemanas();
      }
    });
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/nomina/IngresoRubrosNomina.vue